import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FolderShareFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.42 6.94H20.28V18.54H3.72V4.92H8.84C9.42 4.92 9.76 5.16 10.12 5.44L11.66 6.66C11.88 6.84 12.08 6.94 12.42 6.94ZM8.38 13.4H13.64L12.28 14.76L13.18 15.64L16.02 12.74L13.18 9.84L12.28 10.7L13.62 12.06H8.38V13.4Z" />
    </SvgIcon>
  );
});
